<script>
import { format } from 'date-fns'
import EventBus from '../event-bus'

import store from '@/store'

import Comments from '@/components/journal/Comments'

export default {
  components: {
      Comments
  },
  props: {
    goal: Object,
    visible: Boolean,
    role: String
  },
  data () {
      return {
          format,
          loading: false,
          schoolGoal: false,
          targetDatePicker: {
              disabledDate(time) {
                  return time.getTime() < Date.now()
              }
          },
          form: {}
      }
  },
  mounted() {},
  methods: {
    onSave() {

        this.loading = true

        if (!this.form.GoalID) {

            this.form.CreateDate = format(new Date(), 'X')

            this.form.GoalType = !this.schoolGoal ? 'personal' : 'school' 

            store.dispatch('teacher/createGoal', this.form)
            .then(( data ) => {

                this.loading = false
                
                const el = this.$createElement
                this.$notify({message: el('i', {}, 'goal was created successfully')})

                this.form = {}

                EventBus.$emit('disableVisibility')

                this.$ga.event({
                    eventCategory: 'Create a new goal',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: this.role,
                })
            })
            .catch((error) => {
                console.log(error)
            })
            
        } else {

            this.form.UpdateDate = format(new Date(), 'X')

            this.form.GoalType = !this.schoolGoal ? 'personal' : 'school'

            store.dispatch('teacher/updateGoal', this.form)
            .then(( data ) => {
                data.IsPublished = data.IsPublished === '' ? 0 : 1

                this.loading = false

                const el = this.$createElement
                this.$notify({message: el('i', {}, 'goal was updated successfully')})

                this.form = data

                EventBus.$emit('disableVisibility')

                this.$ga.event({
                    eventCategory: 'Update existing goal',
                    eventAction: store.getters['getDBN']
                        ? store.getters['getDBN']
                        : store.getters['admin/getSelectedSchool']['dbn'],
                    eventLabel: this.role,
                })
            })
            .catch((error) => {
                console.log(error)
            })
        }      
    },
    closeGoal() {
        this.form = {}
        EventBus.$emit('disableVisibility')
    },
    reply(reference) {

        let replies = this.replies

        for (let commentID in replies) {
            if (replies[commentID] && commentID !== reference) {
                replies[commentID].active = false
            }
        }

        if (!replies[reference]) {
            replies[reference] = { active: true }
        } else {
            replies[reference].active = true
        }

        this.replies = Object.assign({}, this.replies, replies)

    }
  },
  computed: {},
  watch: {
      visible (n, o) {
        if (n && this.goal) {
            this.form = this.goal
        } else {
            const {dbn, employeeId, role } = store.state

            this.form.UserID = employeeId
            this.form.SchoolDBN = role.toLowerCase() === 'teacher' ? dbn : store.getters['admin/getSchools'][0].dbn
            this.form.GoalType = role.toLowerCase() === 'teacher' ? 'personal' : null
            
        }
      },
      'goal': {
            handler: function(n) {
                const { employeeId, dbn } = store.state
                const _dbn = dbn !== null ? dbn : store.getters['admin/getSchools'][0].dbn

                const obj = {
                    UserID: employeeId,
                    SchoolDBN: _dbn
                    }
            
                this.form = n !== null ? n : obj
            },
            deep: true
      }
  }
}
</script>

<template>
    <div v-bind:class="{visible: visible}" v-loading="loading" class="goal">
        <button class="exit-btn" @click="closeGoal">x</button>
        <div class="goal-content">
            <el-form class="form" ref="form">
                <div class="section">
                    <span class="display-date">{{form.CreateDate ? format(parseInt(form.CreateDate * 1000), 'MMM. D') : format(new Date(), 'MMM. D')}}</span>
                    <el-form-item>
                        <el-input placeholder="Goal:" v-model="form.GoalTitle"></el-input>
                    </el-form-item>
                </div>
                <div class="section">
                    <el-form-item>
                        <el-input placeholder="What is your goal?" type="textarea" :rows="12" v-model="form.GoalDetail"></el-input>
                    </el-form-item>
                </div>
                <div v-if="role === 'Principal'" class="goal-switch">
                    <el-switch 
                    inactive-text="Personal Goal"
                    active-text="School Goal"
                    v-model="schoolGoal">

                    </el-switch>
                </div>
                <div class="actions">
                    <el-date-picker format="MM/dd/yyyy" value-format="MM/dd/yyyy" v-model="form.GoalTargetDate" type="date" placeholder="Set a target date" :picker-options="targetDatePicker"></el-date-picker>
                    <el-button class="save-btn" @click="onSave">Save</el-button>
                </div>
            </el-form>
        </div>
        <Comments v-if="visible && form.GoalID" referencetype="goal" :referenceid="form.GoalID"></Comments>
    </div>
</template>
<style lang="scss" scoped>
    .goal {
        display: none;
        background-color: rgba(207, 255, 229, 0.72);
        padding: 10px;
        @media screen and (max-width: 1070px) {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: none;
            background-color: #e7dbee;
        }
        .exit-btn {
            padding: 0;
            width: 44px;
            height: 44px;
            font-size: 20px;
            cursor: pointer;
        }
        .save-btn {
            width: 131px;
            height: 25px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0, 0.5);
            background-color: #ae94bd;
        }
        button {
            background-color: transparent;
            border: none;
        }
    }
    .form {
        padding-top: 22px;
        .section {
            position: relative;
            margin: 0 10px 10px 10px;
            background-color: #ffffff;
            .display-date {
                font-family: 'museo_sans';
                z-index: 100;
                position: absolute;
                right: 10px;
                top: 10px;
                color: #000000;
            } 
        }
    }
    .actions {
        margin: 0 10px 10px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .visible {
        display: block;
    }
    .viewOnly {
        pointer-events: none;
    }
    .hide {
        display: none;
    }
    .goal-switch {
        margin-left: 10px;
        margin-bottom: 2em;
    }


</style>